import React from 'react';
import {useIntl} from "react-intl";
import {Modal} from "react-bootstrap";
import {Button} from "react-bootstrap";
import Empty from "../../../_common/components/Empty";

const PopupImportedCustomers = ({
                                  showModal,
                                  handleCloseModal,
                                  markedList = [],
                                  ignoredList = []
                                }) => {
  const intl = useIntl();
  const headerMarkedCustomers = intl.formatMessage({
    id: "projects-popup-header-marked-customers",
    defaultMessage: "List of marked customers:",
  });
  const headerIgnoredCustomers = intl.formatMessage({
    id: "projects-popup-header-ignored-customers",
    defaultMessage: "List of ignored customers",
  });
  const buttonLabelCancel = intl.formatMessage({
    id: "label-button-cancel",
    defaultMessage: "Cancel",
  });

  const getList = (list) => {

    return (
      <ul className={'customersList list-group mt-2'}>
        {list.map((item, index) => {
          const classnames = `list-group-item d-flex justify-content-between align-items-center
          ${index % 2 === 0 ? '' : 'list-group-item-secondary'}`;

          return (
            <li className={classnames} key={index}>
              <span className={'px-2'}>{item.name}</span>
              <span>{item.email}</span>
            </li>
          )
        })}
      </ul>
    )
  };


  return (
    <Modal
      show={showModal}
      onHide={handleCloseModal}
      size={'lg'}
    >
      <Modal.Body>
        {showModal && (markedList.length > 0 || ignoredList.length > 0)
          ? (
          <>
            {showModal && markedList.length > 0 && (
              <>
                <h3 className="card-title font-weight-bold text-dark text-center">
                  {headerMarkedCustomers}
                </h3>
                {getList(markedList)}
              </>
            )}
            {showModal && ignoredList.length > 0 && (
              <>
                <h3 className="card-title font-weight-bold text-dark text-center mt-12">
                  {headerIgnoredCustomers}
                </h3>
                {getList(ignoredList)}
              </>
            )}
          </>
        )
          : <Empty/>
        }
        <div className="d-flex justify-content-center mt-8">
          <Button
            className="btn-secondary btn-sm mx-3 "
            onClick={() => {
              handleCloseModal();
            }}
          >
            {buttonLabelCancel}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PopupImportedCustomers;